import { FC } from 'react';
import StepTitle from './StepTitle';

const ListingTypeTitle: FC = () => (
  <StepTitle
    title="Add Your Job Details"
    description="Provide a few quick details so candidates can find your listing easily."
  />
);

export default ListingTypeTitle;
